import React from 'react';
import { MenuItem, MenuItemProps } from '@chakra-ui/react';

const CustomMenuItem = (props: MenuItemProps) => {
  const focusStyle = { backgroundColor: 'white' };
  return <MenuItem _hover={focusStyle} _focus={focusStyle} {...props} />;
};

export default CustomMenuItem;
